import * as Enumerable from 'linq';
import { DateUtility } from '../../../utilities/date.utility';
import { JobUtility } from '../../../utilities/job.utility';
import { AttributeFilter } from '../../entity';
import { SitePro } from './site.pro';
import { DateTime } from 'luxon';
import { getRequireConfirmationDateFromSite } from '../../job/recurring.job';

export class SiteProIndexUtility {

    public static getAttributeFilter(site: SitePro): AttributeFilter[] {

        const filters: AttributeFilter[] = [];;

        filters.push({ k: 'active', v: site?.active });

        if (site?.type)
            filters.push({ k: 'type', v: site?.type, n: site?.type });

        if (site?.parent) {
            filters.push({ k: 'parent', v: site?.parent?._id, n: site?.parent?.name });
            filters.push({ k: 'parent_type', v: site?.parent?.type, n: site?.parent?.type });
        }

        if (site?.owner)
            filters.push({ k: 'owner', v: site?.owner?._id, n: site?.owner?.name });

        if (site?.billTo)
            filters.push({ k: 'billTo', v: site?.billTo?._id, n: site?.billTo?.name });

        if (site?.manager)
            filters.push({ k: 'manager', v: site?.manager?._id, n: site?.manager?.name });

        if (site.createdAt)
            filters.push({ k: 'createdAt', v: DateUtility.getDate(site.createdAt) });

        if (site.updatedAt)
            filters.push({ k: 'updatedAt', v: DateUtility.getDate(site.updatedAt) });

        if (site?.zones?.length)
            filters.push(...site?.zones?.filter(z => !!z)?.map(zone => ({ k: 'zone', v: zone._id, n: zone.name })));

        if (site?.tags?.length)
            filters.push(...site?.tags?.filter(l => !!l)?.map(label => ({ k: 'tag', v: label._id, n: label.name })));

        if (site?.siteCategory)
            filters.push({ k: 'siteCategory', v: site.siteCategory._id, n: site.siteCategory.name });

        if (site?.schedulingTags?.length)
            filters.push(...site?.schedulingTags?.filter(l => !!l)?.map(label => ({ k: 'scheduling', v: label._id, n: label.name })));

        if (site?.status) {
            const status = site?.status;
            filters.push({ k: 'status', v: status?.parent?._id, n: status?.parent?.name });
            filters.push({ k: 'statusType', v: status?.statusType, n: status?.statusType });
            filters.push({ k: 'statusSubStatus', v: status?._id, n: status?.name });
        }

        if (site?.services?.length) {
            const serviceTypes = site?.services?.map(service => service?.serviceType?._id);

            const nextServiceDates = Enumerable
                .from(site?.services)
                .where(x => !!x.nextServiceDate)
                .select(service => DateUtility.getDate(service?.nextServiceDate))
                .toArray();

            const nextConfirmationDates = Enumerable
                .from(site?.services)
                .where(x => !!x.nextConfirmationDate)
                .select(service => DateUtility.getDate(service?.nextConfirmationDate))
                .toArray();

            const requiresConfirmation = Enumerable.from(site?.services).any(x => x.requiresConfirmation);
            filters.push({ k: 'requiresConfirmation', v: requiresConfirmation });

            if (nextServiceDates.length) {
                filters.push({ k: 'nextServiceDate', v: nextServiceDates });
            }

            if (nextConfirmationDates.length) {
                filters.push({ k: 'nextConfirmationDate', v: nextConfirmationDates });
            }

            if (serviceTypes?.length) filters.push({ k: 'serviceType', v: serviceTypes });


            filters.push({ k: 'requiresConfirmationDate', v: getRequireConfirmationDateFromSite(site) });
        }

        filters.push({ k: 'processingConfirmationDate', v: site?.processingConfirmationDate ?? DateUtility.minDateTime.toJSDate() });
        filters.push({ k: 'actionRequired', v: site?.actionRequired?.value ?? false });
        filters.push({ k: 'responseReceived', v: site?.responseReceived?.value ?? false });

        // Text Filters
        // if (site?.name?.length)
        //     filters.push({ k: 'text', v: site?.name?.toLowerCase() });

        // if (site?.placeId?.length) {
        //     filters.push({ k: 'text', v: site?.placeId?.toLowerCase() });
        // }

        const addressName = site?.address?.name?.trim() ?? JobUtility.address(site?.address);

        const text = [addressName, site.name, site.placeId, site?.parent?.name]
            .filter(x => x?.length)
            .map(x => {
                const words = x
                    .toLowerCase()
                    .split(' ');

                const extendedWords = words
                    .map(x => {

                        const ew = x.indexOf('/') > -1
                            ? [x, ...x.split('/').map(x => x.trim()).flat()]
                            : [x];

                        return ew;

                    })
                    .flat();

                return [...extendedWords];
            })
            .flat();

        filters.push({ k: 'text', v: text });

        // if (site?.address?.street1?.length) {
        //     filters.push({ k: 'address', v: site?.address?.street1?.toLowerCase()?.trim() });
        // }

        // if (site?.address?.street2?.length) {
        //     filters.push({ k: 'address', v: site?.address?.street2?.toLowerCase()?.trim() });
        // }

        // if (site?.address?.suburb.length) {
        //     filters.push({ k: 'address', v: site?.address?.suburb?.toLowerCase()?.trim() });
        // }

        // if (site?.address?.state?.length) {
        //     filters.push({ k: 'address', v: site?.address?.state?.toLowerCase()?.trim() });
        // }

        // if (site?.address?.postalCode?.length) {
        //     filters.push({ k: 'address', v: site?.address?.postalCode?.toLowerCase()?.trim() });
        // }

        // if (site?.address?.postcode) {
        //     filters.push({ k: 'address', v: site?.address?.postcode.toString()?.toLowerCase()?.trim() });
        // }

        return Enumerable
            .from(filters)
            .where(x => x.v !== undefined && x.v !== null && x.v !== '')
            .distinct(x => `${x.k}:${x.v}`)
            .toArray();

    }

}
